<template>
    <div class="home"  id="homeBox">
        <!--    左侧-->


        <div class="contentLeft">
            <reportList  ref="rptlist"   @handleNodeClick="selectedReport" ></reportList>
            <reportdialog  ref="mydialog"   ></reportdialog>
        </div>
        <div class="contentRight" >
            <div class="toolbar" >
                <ul  >
                    <li
                            v-for="item in headerList"
                            :key="item.index"
                            @click.stop="btn(item.id) "
                            style="margin:2px 2px 2px 2px"
                            :class="item.class"
                            :id="item.id"
                            :title="item.title"

                    >
                        <svg  style="width: 1.5em;height: 1.5em;vertical-align: middle;fill: #774917;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" v-html="item.svg">
                        </svg>

                    </li>

                </ul>


            </div>


            <!--    右侧预览框-->
            <div class="contentShadow">
                <div ref="excelView" id="excelView" class="contentExcel" ></div>
            </div>

        </div>
    </div>



</template>

<script>
    // import * as API from "./api"
    // import spd from '@/spreadJs/spreadview.js'
    import * as jUtil from '@/utils/gcExcelJs.js';
    import $ from 'jquery';
    import reportList from "../res//reportList"; // 左侧-模块
    import reportdialog from "../res/reportdialog"; // dialog


    export default {
        name: "reportView",
        components: {
            reportList,
            reportdialog,
        },
        props: {

        },

        data() {
            return {
                headerList: [
                    { title: this.$t('report_fold_up'), id: 'collect',class:'gc-button  ' , svg:'<path d="M667.008 701.856c7.072 0 12.8 5.76 12.8 12.8v42.688a12.8 12.8 0 0 1-12.8 12.8H172.8a12.8 12.8 0 0 1-12.8-12.8v-42.688c0-7.04 5.76-12.8 12.8-12.8h494.208z m182.592-374.944a12.8 12.8 0 0 1 3.744 9.056v322.208a12.8 12.8 0 0 1-21.856 9.024l-147.52-147.52a32 32 0 0 1 0-45.248l147.52-147.52a12.8 12.8 0 0 1 18.112 0z m-267.2 136c7.04 0 12.8 5.76 12.8 12.8V518.4a12.8 12.8 0 0 1-12.8 12.8H172.8a12.8 12.8 0 0 1-12.8-12.8v-42.656c0-7.072 5.76-12.8 12.8-12.8h409.6zM667.008 224c7.072 0 12.8 5.76 12.8 12.8v42.656a12.8 12.8 0 0 1-12.8 12.8H172.8a12.8 12.8 0 0 1-12.8-12.8V236.8c0-7.04 5.76-12.8 12.8-12.8h494.208z" p-id="5918"></path>'},
                    { title: this.$t('report_expand'), id: 'expend' ,class:'gc-button  gc-button-hide', svg:'<path d="M356.992 701.856a12.8 12.8 0 0 0-12.8 12.8v42.688c0 7.04 5.728 12.8 12.8 12.8H851.2a12.8 12.8 0 0 0 12.8-12.8v-42.688a12.8 12.8 0 0 0-12.8-12.8H356.992zM174.4 326.912a12.8 12.8 0 0 0-3.744 9.056v322.208a12.8 12.8 0 0 0 21.856 9.024l147.52-147.52a32 32 0 0 0 0-45.248l-147.52-147.52a12.8 12.8 0 0 0-18.112 0z m267.2 136a12.8 12.8 0 0 0-12.8 12.8V518.4c0 7.04 5.76 12.8 12.8 12.8h409.6a12.8 12.8 0 0 0 12.8-12.8v-42.656a12.8 12.8 0 0 0-12.8-12.8H441.6zM356.992 224a12.8 12.8 0 0 0-12.8 12.8v42.656c0 7.072 5.728 12.8 12.8 12.8H851.2a12.8 12.8 0 0 0 12.8-12.8V236.8a12.8 12.8 0 0 0-12.8-12.8H356.992z" p-id="13229"></path>'},
                    { title: this.$t('report_run'), id: 'run',class:'gc-button  ' , svg:'<path d="M912 512l-800 448V64z" fill="#0590DF" p-id="98309"></path>'},
                    { title: this.$t('report_reduce'), id: 'zoom-in' ,class:'gc-button  ',svg:'<path d="M945.066667 898.133333l-189.866667-189.866666c55.466667-64 87.466667-149.333333 87.466667-241.066667 0-204.8-168.533333-373.333333-373.333334-373.333333S96 264.533333 96 469.333333 264.533333 842.666667 469.333333 842.666667c91.733333 0 174.933333-34.133333 241.066667-87.466667l189.866667 189.866667c6.4 6.4 14.933333 8.533333 23.466666 8.533333s17.066667-2.133333 23.466667-8.533333c8.533333-12.8 8.533333-34.133333-2.133333-46.933334zM469.333333 778.666667C298.666667 778.666667 160 640 160 469.333333S298.666667 160 469.333333 160 778.666667 298.666667 778.666667 469.333333 640 778.666667 469.333333 778.666667zM597.333333 437.333333H341.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h256c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32z" fill="#205f78" p-id="1484"></path>'},
                    { title: this.$t('report_magnify'), id: 'zoom-out' ,class:'gc-button  ',svg:'<path d="M945.066667 898.133333l-189.866667-189.866666c55.466667-64 87.466667-149.333333 87.466667-241.066667 0-204.8-168.533333-373.333333-373.333334-373.333333S96 264.533333 96 469.333333 264.533333 842.666667 469.333333 842.666667c91.733333 0 174.933333-34.133333 241.066667-87.466667l189.866667 189.866667c6.4 6.4 14.933333 8.533333 23.466666 8.533333s17.066667-2.133333 23.466667-8.533333c8.533333-12.8 8.533333-34.133333-2.133333-46.933334zM469.333333 778.666667C298.666667 778.666667 160 640 160 469.333333S298.666667 160 469.333333 160 778.666667 298.666667 778.666667 469.333333 640 778.666667 469.333333 778.666667zM597.333333 437.333333h-96V341.333333c0-17.066667-14.933333-32-32-32s-32 14.933333-32 32v96H341.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h96V597.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-96H597.333333c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32z"  fill="#205f78" p-id="1512"></path>'},
                    { title: this.$t('report_print'), id: 'print' ,class:'gc-button  ',svg:'<path d="M944 338.48H100a32 32 0 0 0-32 32v283.08a32 32 0 0 0 32 32h107.48v-105.04H158a8 8 0 0 1 0-16h708a8 8 0 0 1 0 16h-49.48v105.04H944a32 32 0 0 0 32-32V370.48a32 32 0 0 0-32-32zM342.04 408.72a8 8 0 0 1-8 8H273.52a8 8 0 0 1 0-16h60.52a8 8 0 0 1 8 8z m-121.04 0a38.28 38.28 0 0 1-38.24 38.24H122.24a38.24 38.24 0 0 1 0-76.52h60.52a38.32 38.32 0 0 1 38.28 38.28z" fill="#40BDFF" p-id="37940"></path><path d="M182.76 386.48H122.24a22.24 22.24 0 0 0 0 44.52h60.52a22.24 22.24 0 0 0 0-44.52z" fill="#EB5639" p-id="37941"></path><path d="M182.76 386.48h-12a22.24 22.24 0 0 1 0 44.52h12a22.24 22.24 0 0 0 0-44.52z" fill="#D84936" p-id="37942"></path><path d="M275.48 927.6h493.04a32 32 0 0 0 32-32v-315.08H243.48v315.08a32 32 0 0 0 32 32z m6.56-60.52h460a8 8 0 0 1 0 16h-460a8 8 0 0 1 0-16z m460-44.52h-460a8 8 0 0 1 0-16h460a8 8 0 0 1 0 16z m0-60.52h-460a8 8 0 0 1 0-16h460a8 8 0 0 1 0 16z m0-60.52h-460a8 8 0 0 1 0-16h460a8 8 0 0 1 0 16z m0-60.52h-460a8 8 0 0 1 0-16h460a8 8 0 0 1 0 16zM800.52 128.4a32 32 0 0 0-32-32H275.48a32 32 0 0 0-32 32v194.08h557.04z" fill="#EFFAFE" p-id="37943"></path><path d="M944 338.48h-20a32 32 0 0 1 32 32v283.08a32 32 0 0 1-32 32h20a32 32 0 0 0 32-32V370.48a32 32 0 0 0-32-32z" fill="#2197F7" p-id="37944"></path><path d="M780.52 580.52v315.08a32 32 0 0 1-32 32h20a32 32 0 0 0 32-32v-315.08zM768.52 96.4h-20a32 32 0 0 1 32 32v194.08h20V128.4a32 32 0 0 0-32-32z" fill="#E4EBED" p-id="37945"></path><path d="M944 320.48h-125.48v-192a50.04 50.04 0 0 0-50-50H255.48a50.04 50.04 0 0 0-50 50v192H80a50.04 50.04 0 0 0-50 50v283.08A50.04 50.04 0 0 0 80 703.52h125.48v192a50.04 50.04 0 0 0 50 50h513.04a50.04 50.04 0 0 0 50-50v-192H944a50.04 50.04 0 0 0 50-50V370.48a50.04 50.04 0 0 0-50-50zM225.48 128.4a30.04 30.04 0 0 1 30-30h513.04a30.04 30.04 0 0 1 30 30v192H225.48z m573.04 565.12v202.08a30.04 30.04 0 0 1-30 30H255.48a30.04 30.04 0 0 1-30-30v-313.08h573.04z m175.48-40a30.04 30.04 0 0 1-30 30h-125.48v-101h47.48a10 10 0 0 0 0-20h-708a10 10 0 0 0 0 20h47.48v101.04H80a30.04 30.04 0 0 1-30-30V370.48a30.04 30.04 0 0 1 30-30h864a30.04 30.04 0 0 1 30 30z" fill="#263238" p-id="37946"></path><path d="M182.76 368.48H122.24a40.24 40.24 0 0 0 0 80.52h60.52a40.24 40.24 0 0 0 0-80.52z m0 60.52H122.24a20.24 20.24 0 0 1 0-40.52h60.52a20.24 20.24 0 0 1 0 40.52zM334.04 398.72H273.52a10 10 0 0 0 0 20h60.52a10 10 0 0 0 0-20zM282.04 643.04h460a10 10 0 0 0 0-20h-460a10 10 0 0 0 0 20zM282.04 703.52h460a10 10 0 0 0 0-20h-460a10 10 0 0 0 0 20zM282.04 764h460a10 10 0 0 0 0-20h-460a10 10 0 0 0 0 20zM282.04 824.56h460a10 10 0 0 0 0-20h-460a10 10 0 0 0 0 20zM282.04 885.08h460a10 10 0 0 0 0-20h-460a10 10 0 0 0 0 20z" fill="#263238" p-id="37947"></path><path d="M92 784h-16v-16a4 4 0 0 0-8 0v16h-16a4 4 0 0 0 0 8h16v16a4 4 0 0 0 8 0v-16h16a4 4 0 0 0 0-8zM932 753h-16v-16a4 4 0 0 0-8 0v16h-16a4 4 0 0 0 0 8h16v16a4 4 0 0 0 8 0v-16h16a4 4 0 0 0 0-8z" fill="#FFDD00" p-id="37948"></path><path d="M105.28 112h-16v-16a4 4 0 0 0-8 0v16h-16a4 4 0 0 0 0 8h16v16a4 4 0 0 0 8 0v-16h16a4 4 0 0 0 0-8zM880 126.4a24 24 0 1 1 24-24 24 24 0 0 1-24 24z m0-40a16 16 0 1 0 16 16 16 16 0 0 0-16-16zM152.52 964a24 24 0 1 1 24-24 24 24 0 0 1-24 24z m0-40a16 16 0 1 0 16 16 16 16 0 0 0-16-16z" fill="#40BDFF" p-id="37949"></path><path d="M910.88 291a24 24 0 1 1 24-24 24 24 0 0 1-24 24z m0-40a16 16 0 1 0 16 16 16 16 0 0 0-16-16z" fill="#FFDD00" p-id="37950"></path><path d="M913.32 914h-10.36l7.32-7.32a4 4 0 0 0-5.64-5.64l-7.32 7.32v-10.36a4 4 0 0 0-8 0v10.36l-7.32-7.32a4 4 0 0 0-5.64 5.64l7.32 7.32h-10.36a4 4 0 0 0 0 8h10.36l-7.32 7.32a4 4 0 0 0 5.64 5.64l7.32-7.32v10.36a4 4 0 0 0 8 0v-10.36l7.32 7.32a4 4 0 0 0 5.64-5.64l-7.32-7.32h10.36a4 4 0 0 0 0-8z" fill="#40BDFF" p-id="37951"></path>'},
                    { title: this.$t('report_save_as'), id: 'saveas' ,class:'gc-button  ',svg:'<path d="M943.5 179.7H643.2v55.6h88.5v87.9h-88.5v28h88.5v88h-88.5V468h88.5v83.2h-88.5v33.4h88.5V668h-88.5v33.4h88.5v83.9h-88.5v61.2h300.3c4.7-1.4 8.7-7 11.9-16.7 3.2-9.8 4.8-17.7 4.8-23.8V189.8c0-4.8-1.6-7.7-4.8-8.7-3.9-1-7.9-1.5-11.9-1.4z m-39 605.5h-144v-83.8h144.1l-0.1 83.8z m0-117.2h-144v-83.5h144.1l-0.1 83.5z m0-116.8h-144v-82.9h144.1l-0.1 82.9z m0-112h-144v-87.9h144.1l-0.1 87.9z m0-116.5h-144v-87.4h144.1v88l-0.1-0.6zM63.8 165.8v694.7L592.7 952V72L63.8 166.1v-0.3z m313.5 525.5c-2-5.5-11.5-28.6-28.3-69.6-9.7-23.9-19.7-47.8-29.8-71.6h-0.9l-56.7 135-75.8-5.1 89.8-168-82.4-168 77.3-4.1 51.1 131.5h1l57.7-137.5 79.9-5-95.1 181.9 98 185.5-85.8-5z" fill="#107B0F" p-id="73485"></path>'},
                    { title: this.$t('button_close'), id: 'close' ,class:'gc-button  ',svg:'<path d="M580.198 509.487l176.777-176.776L686.265 262 509.486 438.777 332.711 262 262 332.71l176.777 176.777L262 686.264l70.71 70.71 176.777-176.776 176.777 176.777 70.71-70.71-176.776-176.778zM512 962C263.472 962 62 760.528 62 512S263.472 62 512 62s450 201.472 450 450-201.472 450-450 450z" fill="#1AA5FF" p-id="64845"></path>'},

                ],
                fileName: "",
                spread: {},
                excelIo:{},
                rptJson:{},
                rptParm:{},
                isFirstView:true,
                spreadNS : GC.Spread.Sheets,
                spreadStyle: {
                    width: '100%',
                    height: '100%'
                }
            };
        },

        computed:{

        },

        watch: {

        },

        activated(){
            this.onResize();
        },

        mounted() {
            this.spread=new this.spreadNS.Workbook($('#excelView')[0]);

            this.excelIo =new GC.Spread.Excel.IO();
            window.addEventListener("resize",this.onResize);
            this.onResize();

        },
        beforeDestroy(){
            window.removeEventListener("resize",this.onResize);
        },
        methods: {
            onResize (){
                $(".home").height($(".layout-main__view").height()*1 );
                $(".home").width($(".layout-main__view").width());
                $('.contentRight').width($(".home").width() - $('.contentLeft').width() );
                this.spread.refresh();

            },

            //另存为（本地保存）
            locationSave(){
                let ex = spd.excelIO_spd;
                let json =spd.spread.toJSON({includeBindingSource:true});
                const that=this;
                ex.save(json, function (blob) {
                    FaverSaver.saveAs(blob, 'export.xlsx');

                }, function (e) {
                });
            },
            selectedReport(item){
                this.rptParm= {
                    fid:item.path,
                    filename:item.name,
                    level:0,
                };
                 this.isFirstView=true;
                this.loadReportData();
            },
            //打开报表模板 item:left tree node
            async  loadReport(){
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                let res = await jUtil.loadReportData(this.rptParm);
               if (res.code==1) {
                    spd.spread.fromJSON(res.gcExcel);
                    if (this.rptParm.level == 0) this.$refs.rptlist.setParmDetail(res.set, res.parmdata);
                }
                else
                {
                    this.$refs.mydialog.showDialog({text:this.$t('report_report_loading_failed')+"!("+res.message+")"});}
                loading.close();

            },

            //打开报表模板 item:left tree node
            async  loadReportData(){
                var _this=this;
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                let res = await jUtil.loadReportData(this.rptParm);
                if (res.code==1) {
                    _this.spread.fromJSON(res.gcExcel);
                    _this.parmData=res.parmdata;

                    _this.$refs.rptlist.setParmDetail(res.set,res.parmdata,res.argdata);
                    _this.isFirstView=false;

                    //   this.$refs.jview.jsonDataLoad({"报表生成":"成功执行."});
                }
                else
                {
                    //this.$refs.mydialog.showDialog({text:this.$t('report_report_loading_failed')+"!("+res.message+")"});
                    //this.$refs.jview.jsonDataLoad(res);
                    //this.activeName='info';
                }


                loading.close();

            },


            //loadDataFromSvr接口
            async loadBookFromSvr() {
            },
            async loadDataFromSvr(){
                let param = {
                    filename:'202201114628065d07da4a77621450aa84fee5656d9',
                    type:'data',
                    arg:{"jssj":"202112 ","cjid":"625","type":"1"},
                    sn:0,
                };
                let res = await jUtil.loadDataFromSvr(param);
                //console.log(res,"res");

                if (res) {


                    // jUtil.beforeLoadData(this.spread,res,this.spread.getActiveSheetIndex());

                    window.setTimeout(function () {
                        //hideLoading();
                        try {
                            jUtil.beforeLoadData(data,this.spread.getActiveSheetIndex());
                        } catch (ex) {
                        }
                    }, 600);

                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    //this.$message.error(res.message);
                }else{
                    //this.$message.error(res.message);
                }
            },

            //关闭
            cancel() {
                //console.log(this.pageSize,"------")
                this.$emit('close');
            },


            exportXlsx () {
                //只需要拿到json
                let ex = spd.ExcelIO_spd;
                let json = this.spread.toJSON();
                //console.log(ex,json,"IO");
                ex.save(json, function (blob) {
                    FaverSaver.saveAs(blob, 'export.xlsx')
                }, function (e) {
                    //console.log(e,"12345")
                });
                ///调保存接口
            },




            ///////////////////

            //上传EXCEL
            upExcel(){
                var excelFile = document.getElementById("upload_file").files[0];
                this.excelIo.open(excelFile, (json) => {
                    var workbookObj = json;
                    this.spread.fromJSON(workbookObj);
                }, function (e) {
                    alert('文件读取失败，仅支持xlsx类型');
                });
            },

            //选择文件
            selectExcel(){
                upload_file.click();
            },
            changeExcel(){
                var excelFile = document.getElementById("upload_file").files[0];
                this.fileName = document.getElementById("upload_file").files[0].name;
                //this.upExcel();
            },

            //保存EXCEL
            saveExcel(){
                //生成时间戳
                var fileName = new Date().getTime() + '.xlsx';
                var json = this.spread.toJSON();
                //console.log("excel",json);
                this.excelIo.save(json, (blob) => {
                    //console.log("excel",blob,fileName);
                    saveAs(blob, fileName);

                }, function (e) {
                    //console.log(e);
                });
            },
            //保存模板
            saveTemplate(){
                //生成时间戳

                var fileName = new Date().getTime() + '.json';
                var json = this.spread.toJSON();
                var jsontext = JSON.stringify(json);
                //前台保存
                saveAs(new Blob([jsontext], {type: "text/plain;charset=utf-8"}), fileName);
                //保存后台
                let formData = new FormData();
                // var thefile = document.getElementById("upload_file").files[0];
                var thefile = this.filesdata.version;
                formData.append("file", thefile);
                //formData.append("fileName", thefile.name);
                //console.log(thefile,formData,"存后台");
                axios.post('/admin/excelup/doImport', formData).then(function (response) {
                    alert("模板保存成功");
                }).catch(function (error) {
                    alert("上传失败");
                    //console.log(error);
                });

            },

            btn(id){

                switch (id) {
                    case 'run':


                        let args=this.$refs.rptlist.getArgsObj();

                        this.rptParm.arg=args;
                        this.rptParm.level=0;
                        this.loadReportData();
                        //this.loadReport();
                        break;
                    case 'collect':
                        $('#collect').hide();
                        $('#expend').show();
                        $('.contentLeft').hide();
                        $('.contentLeft').width(0);
                        this.onResize();
                        break;
                    case 'expend':
                        $('#expend').hide();
                        $('#collect').show();
                        $('.contentLeft').show();
                        $('.contentLeft').width(260);
                        this.onResize();
                        break;
                    case 'zoom-in':
                        var zoom=this.spread.getActiveSheet().zoom();
                        this.spread.getActiveSheet().zoom(zoom -0.1);
                        break;
                    case 'zoom-out':
                        var zoom=this.spread.getActiveSheet().zoom();
                        this.spread.getActiveSheet().zoom(zoom +0.1);
                        break;
                    case 'print':
                        let sheet =this.spread.getActiveSheet();
                        let printInfo = sheet.printInfo();
                        printInfo.showBorder(false);
                        printInfo.showGridLine(false);
                        this.spread.print(0);
                        break;
                    case 'saveas':
                        this.saveExcel();
                        break;
                    case 'save':  //save
                        var _this=this;
                        const res3 = ds.setThemeObj(this.themeItem,jUtil.getThemeData()).then(function (result){
                            if (result.code == 1) {

                                //console.log("res", result);
                            }
                        })
                        break;
                    default: break;
                }

            },
        },
    }
</script>


<style lang="scss" >

    .home {

        width:100%;
        ul {
            display: flex;
        }

        .contentLeft {
            float:left;
            width: 260px;
            height:calc(100% - 1px);
            border-bottom: 1px  solid #d5d7da;
            z-index: 100;
        }
        .contentRight{
            height:calc(100% - 1px);
            float:left;
            z-index: 1000;
            border-bottom: 1px  solid #d5d7da;
        }

        .toolbar  {
            float:left;background: #fff;width:auto;border-bottom: 0px solid #ccc;height:40px;
        }
        .contentParm {
            margin-left:30px;float:right;background: #fff;width:auto;border-bottom: 0px solid #ccc;height:40px;
        }
        .contentShadow {
            float:left;

            width: calc(100%) ;
            height:calc(100% - 44px) ;
            overflow:hidden;
            background: #fff;
            border-top: 1px solid #c5cfc8;

        }

        .contentExcel {
            margin: 0;
            padding: 0;
            width: calc(100% ) ;
            height: calc(100%) ;
            overflow: hidden;
            background: #fff;

        }

        .gc-button {
            background: #FFFFFF;
            border: 0px solid  #fff;
            padding: 5px 10px;
            border-radius: .25rem;
            outline: none;
            cursor: pointer
        }

        .gc-button:hover {
            background: #d3d3d3
        }

        .gc-button-hide{
            display:none;
        }
        .selectDiv {

            opacity: 0.9;
            border: 1px solid #1b59ac;
            background-color: #87b6cf;

        }

        .selectDivRed {
            border: 1px dashed #888787;
            background: rgba(#ac2925, 0.26);
            opacity: 0.7;
            border: 2px solid #ac3333;
            background-color: #blue;
        }







        ::-webkit-scrollbar-track-piece {
            background-color: #f5f5f5;
            border-left: 1px solid #d2d2d2;
        }

        ::-webkit-scrollbar {
            width: 12px;
            height: 13px;
        }

        ::-webkit-scrollbar-thumb {
            border: 1px solid #d9d9e1;
            background-color: #d9d9e1;
            border-radius: 10px;
        }

        ::-webkit-scrollbar-thumb:hover {
            border: 1px solid #bbb5b5;
            background-color: #bbb5b5;
        }

        .div12 {
            padding: 0 12px 6px 12px;
            width: 400px;
        }

        .s011 {
            width: 400px;
        }

        .contentBox {
            height: 680px;
            overflow: hidden;
            position: relative;
            width: 420px;
        }

    }





    .gridbackground { /*网格背景*/
        /*90度直线，100灰度，0.1透明度，5%宽度，0透明度背景*/
        background: linear-gradient(90deg, rgba(213, 213, 213, 0.5) 5%, transparent 0),
            /*0度直线，100灰度，0.1透明度，5%宽度，0透明度背景*/
        linear-gradient(rgba(213, 213, 213, 0.5) 5%, transparent 0);
        /*横纵向宽距*/
        background-size: 20px 20px;
    }

    .attributeBox {
        position: absolute;
        background-color: #e4e0e2;
        right: 0;
        top: 0px;
        border: 1px dashed #efd773;
        min-height: calc(100vh - 300px);
        width: 32%;
        height: 680px;
        overflow: hidden;

        .group-title {
            span {
                display: inline-block;
                height: 30px;
                text-align: center;
                line-height: 30px;
                position: absolute;
            }

            group-name {
                display: inline-block;
                height: 30px;
                text-align: center;
                line-height: 30px;
                position: absolute;
                top: 10px;
            }

            div {
                height: 20px;
                width: 200px;
                margin-left: 90px;
                align: center;
                text-align:center;
            }

        }
        .input {
            height: 30px;
            width: 100%;
            border: 1px solid #6b9893;
            border-radius: 4px;
        }
        .upload_img {
            max-height:100%;
            max-width: 100%;
            align: center;
            margin:0px;
        }
        .dataSelect {
            margin-top: 10px;
            position: relative;

            span {
                display: inline-block;
                height: 30px;
                text-align: center;
                line-height: 30px;
                position: absolute;
            }

            select {
                display: block !important;
                width: 200px;
                height: 30px;
                margin-left: 90px;
                border: 1px solid #6b9893;
                border-radius: 4px;
            }
        }

        .selectpicker {
            display: block !important;
            width: 60%;
            margin-left: 100px;
            border: 1px solid rgb(193, 222, 250);
            border-radius: 4px;
        }

        .select_list {
            border: solid 2px #96cffd;
            font-size: 30px;
            padding-left: 20px;
            /*很关键：将默认的select选择框样式清除*/
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;

            background-position-x: 330px;
        }
        .pagination{

        }
    }
    .box-normal{
        position: relative;
        border: 1px solid #ac3333;; border-radius: 4px;
        padding:20px;
    }

    .ul_list {
        width: 100%;

        li {
            width: 100%;
            height: 30px;
            float: left;
            display: block;
        }
    }

</style>

